module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flexContainer full"
  }, [_c('section', {
    attrs: {
      "id": "sectionPrincipal"
    }
  }, [_c('AdminTools'), _vm._v(" "), _c('section', {
    staticClass: "brand-list"
  }, [_c('section', {
    staticClass: "searchResultsWrapper tabletNot"
  }, [_c('section', [_c('div', {
    staticClass: "flexContainer ai-c jc-sb"
  }, [_c('div', {
    staticClass: "flexContainer ai-c jc-sb"
  }, [_c('span', {
    staticClass: "btnExp iBlock pointer txtCenter active fright",
    on: {
      "click": function($event) {
        _vm.toggleCreateModal(true);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("brand.create")))])])]), _vm._v(" "), _c('hr', {
    staticClass: "full mt10 separator"
  }), _vm._v(" "), _c('transition-group', {
    staticClass: "resultsWrapper flexContainer fw-w ",
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.brandList), function(brand) {
    return (brand.active !== false) ? _c('div', {
      key: brand.name,
      staticClass: "listDisplay rel full flexContainer fd-c ai-c jc-fs",
      class: [brand['theme']]
    }, [_c('div', {
      staticClass: "listDisplay rel full flexContainer fd-c ai-c jc-fs list"
    }, [_c('div', {
      staticClass: "listDisplay full ai-c jc-sb flexContainer"
    }, [_c('figure', {
      staticClass: "jc-c ac-c ai-c size1of6 txtCenter"
    }, [_c('img', {
      staticClass: "ac-c mt25",
      attrs: {
        "src": _vm.getImgPathFig(brand.imgPath, brand.logo),
        "width": "100"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "flexContainer fd-c size1of6"
    }, [_c('span', {
      staticClass: "listTitle uppercase center"
    }, [_vm._v(_vm._s(brand.name))])]), _vm._v(" "), _c('div', {
      staticClass: "size1of6"
    }, [_c('ul', _vm._l((brand.applications), function(app, key) {
      return _c('li', {
        key: key
      }, [_vm._v("\n                                                " + _vm._s(_vm.getTranslate(app.application.terms.name)) + "\n                                            ")])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "flexContainer fd-c size2of5"
    }, [(brand.createdUser.hasOwnProperty('firstname')) ? _c('span', [_vm._v("\n                                            " + _vm._s(_vm.$t("campaignList.createdBy")) + " " + _vm._s(brand.createdUser.firstname) + " " + _vm._s(brand.createdUser.lastname) + "\n                                            " + _vm._s(_vm.$t("campaignList.createdOn")) + " " + _vm._s(brand.createdUser.dateCreated) + "\n                                        ")]) : _vm._e(), _vm._v(" "), (brand.modifiedUser.hasOwnProperty('firstname')) ? _c('span', [_vm._v("\n                                            " + _vm._s(_vm.$t("campaignList.modifiedBy")) + " " + _vm._s(brand.modifiedUser.firstname) + "\n                                            " + _vm._s(brand.modifiedUser.lastname) + " " + _vm._s(_vm.$t("campaignList.modifiedOn")) + "\n                                            " + _vm._s(brand.modifiedUser.modifiedDate) + "\n                                        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "fd-c size1of6 content-button"
    }, [_c('span', {
      staticClass: "roundedIcon pointer",
      on: {
        "click": function($event) {
          _vm.editBrand(brand);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-pencil-alt"
    })]), _vm._v(" "), _c('span', {
      staticClass: "roundedIcon pointer",
      on: {
        "click": function($event) {
          _vm.editNotificationList(brand);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-list"
    })]), _vm._v(" "), _c('span', {
      staticClass: "roundedIcon pointer",
      on: {
        "click": function($event) {
          _vm.deleteBrand(brand.id);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-trash-alt"
    })])])])])]) : _vm._e()
  }))], 1)])]), _vm._v(" "), (_vm.editStand) ? _c('EditBrand', {
    on: {
      "hideEditBrand": function($event) {
        _vm.modalClose($event);
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showNotificationListsModal) ? _c('NotificationListsModal', {
    on: {
      "close": function($event) {
        _vm.toggleNotificationList(false);
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showCreateModal) ? _c('CreateBrand', {
    on: {
      "close": function($event) {
        _vm.toggleCreateModal(false);
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-539c87a3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/brand/BrandList.vue
// module id = 3186
// module chunks = 0